module.exports = __webpack_public_path__ + "static/img/ee0c27f.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/dy/twopart.png
// module id = 638
// module chunks = 2